import { render, staticRenderFns } from "./dashboardRecent.vue?vue&type=template&id=05015456&"
import script from "./dashboardRecent.vue?vue&type=script&lang=js&"
export * from "./dashboardRecent.vue?vue&type=script&lang=js&"
import style0 from "./dashboardRecent.vue?vue&type=style&index=0&id=05015456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports